<!-- メニュー -->
<app-menu></app-menu>

<!-- メイン -->
<div class="main">
  <!-- メインコンテンツ -->
  <div class="main-content" [class.platform-large-text]="getTextSize()">
    <!-- G100系共通部品_Steps -->
    <app-l300-steps></app-l300-steps>

    <!-- タイトル -->
    <div class="title">
      <a
        pButton
        href="https://future-city.go.jp/platform/inquire/#kanminrenkei-chatroom"
        class="p-button-text">
        官民連携チャットルームのよくある質問へ<span class="p-button-icon p-button-icon-right pi pi-angle-right" aria-hidden="true"></span>
      </a>

      <h1>
        <label *ngIf="!confirmationFlag">スレッドの登録</label>
        <label *ngIf="confirmationFlag">登録内容確認</label>
      </h1>
    </div>

    <!-- お知らせ登録(l301)) -->
    <div *ngIf="!confirmationFlag">
      <!-- 入力フォーム -->
      <form [formGroup]="l301InputForm">
        <!-- お知らせ情報 -->
        <div class="information">
          <!-- 備考 -->
          <div class="note">
            <label>
              以下の項目に必要事項をご記載後、「確認画面へ進む」ボタンをクリックしてください。<br />
              <label class="warning">【必須】の項目は入力必須項目です。必ずご記載ください。
              </label>
            </label>
          </div>

          <!-- サブタイトル -->
<!--          <div class="sub-title">-->
<!--            <h2>掲示板スレッド</h2>-->
<!--          </div>-->
          <!-- お知らせ情報内容 -->
          <p-table [value]="[{}]" styleClass="information-Form">
            <ng-template pTemplate="body">
              <!-- タイトル -->
              <tr>
                <td class="item-name">
                  スレッドタイトル
                  <span class="required">【必須】</span>
                </td>
                <td class="item-information">
                  <input type="text" pInputText class="information-Form-inputtext-wMax" formControlName="title" />
                  <!-- エラーメッセージ出力箇所 -->
                  <app-validator-message [control]="l301InputForm.get('title')">
                  </app-validator-message>
                </td>
              </tr>
              <!-- お知らせ内容 -->
              <tr>
                <td class="item-name">
                  書き込み内容
                  <span class="required">【必須】</span>
                </td>
                <td class="item-information">
                  <textarea pInputTextarea formControlName="content"></textarea>
                  <!-- エラーメッセージ出力箇所 -->
                  <app-validator-message [control]="l301InputForm.get('content')">
                  </app-validator-message>
                </td>
              </tr>
              <!-- 匿名投稿 -->
              <tr>
                <td class="item-name">
                  匿名投稿
                  <span class="required">【必須】</span>
                </td>
                <td class="item-information">
                  <p-checkbox
                    id="is_anonymous"
                    [binary]="true"
                    [(ngModel)]="isAnonymousChecked"
                    (onChange)="onAnonymousChange($event)"
                    [ngModelOptions]="{standalone: true}"
                  ></p-checkbox>
                </td>
              </tr>
            </ng-template>
          </p-table>
        </div>
      </form>

      <!-- ヴァリデーションチェックメッセージエリア -->
      <div class="p-d-flex p-jc-center error-area" *ngIf="!l301InputForm.valid">
        <label class="warning platform-warning-text">
          未入力の項目、またはエラーがあります。
        </label>
      </div>
      <!-- 余白エリア -->
      <div class="p-d-flex p-jc-center error-area" *ngIf="l301InputForm.valid">
        <label class="warning platform-warning-text">
          &nbsp;
        </label>
      </div>

      <!-- ボタンエリア [disabled]="!l301InputForm.valid"-->
      <div class="p-d-flex p-jc-center button-area">
        <button pButton type="button" label="確認画面へ進む" class="button-default-size button1"
                [disabled]="!l301InputForm.valid" (click)="moveL302()"></button>
      </div>
    </div>

    <!------------------------------------------------------------------------->

    <!-- お知らせ登録確認(G104)) -->
    <div *ngIf="confirmationFlag">
      <!-- お知らせ情報 -->
      <div class="subcommittee-information">
        <!-- 備考 -->
        <div class="note">
          下記内容でよろしければ、「登録する」ボタンを押して下さい。
        </div>

        <!-- サブタイトル -->
        <div class="sub-title">
          <h2>スレッドの概要</h2>
        </div>
        <!-- お知らせ情報内容 -->
        <p-table [value]="[{}]" styleClass="information-Form">
          <ng-template pTemplate="body">
            <!-- タイトル -->
            <tr>
              <td class="item-name">
                スレッドタイトル
                <span class="required">【必須】</span>
              </td>
              <td class="item-information">
                {{ l301InputForm.value.title }}
              </td>
            </tr>
            <!-- お知らせ内容 -->
            <tr>
              <td class="item-name">
                書き込み内容
                <span class="required">【必須】</span>
              </td>
              <td class="item-information">
                {{ l301InputForm.value.content }}
              </td>
            </tr>
          <!-- 匿名投稿 -->
          <tr>
            <td class="item-name">
              匿名投稿
            </td>
            <td class="item-information">
              <i
                class="pi"
                [ngClass]="{
                  'pi-check': l301InputForm.value.is_anonymous === 1,
                  'pi-times': (l301InputForm.value.is_anonymous === 0 || l301InputForm.value.is_anonymous == '')
                }"
                aria-hidden="true"
              ></i>
          </tr>
          </ng-template>
        </p-table>
      </div>
      <!-- 余白エリア -->
      <div class="p-d-flex p-jc-center error-area">
        <label class="warning platform-warning-text">
          &nbsp;
        </label>
      </div>

      <!-- ボタンエリア -->
      <div class="p-d-flex p-jc-center button-area">
        <button pButton type="button" label="登録する" class="button-default-size button1" (click)="moveL303()"></button>
        <button pButton type="button" label="修正する" class="button-default-size button2" (click)="moveL301()"></button>
      </div>
    </div>
  </div>
</div>

<!-- フッダー -->
<footer>
  <app-footer></app-footer>
</footer>
